import BaseService from "@/services/BaseService";
import { http } from "@/services/config";
class RelatorioVendaService extends BaseService {
  vendasPorPeriodo(data) {
    // const queryParams = `
    // periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ""}
    // &periodo_final=${data.periodo_final ? data.periodo_final : ""}
    // &formaPagamentoId=${data.formaPagamentoId ? data.formaPagamentoId : ""}
    // `;
    return http.get(`/v1/relatorio/vendas/periodo`, {params: data});
  }
  comissao(data) {
    // const queryParams = `periodo_inicial=${
    //   data.periodo_inicial ? data.periodo_inicial : ""
    // }
    // &periodo_final=${data.periodo_final ? data.periodo_final : ""}
    // &funcionario_id=${data.funcionario_id ? data.funcionario_id : ""}`;

    return http.get(`/v1/relatorio/vendas/comissao`, {params: data});
  }
  produtosVendidos(data) {
    // const queryParams = `periodo_inicial=${
    //   data.periodo_inicial ? data.periodo_inicial : ""
    // }
    // &periodo_final=${data.periodo_final ? data.periodo_final : ""}
    // &marca_produto=${data.marca ? data.marca : ""}
    // &produtoId=${data.produto_id ? data.produto_id : ""}
    // &grupoId=${data.grupoId ? data.grupoId : ''}
    // `;

    return http.get(`/v1/relatorio/produtos/vendas`, {params: data});
  }
}

export default new RelatorioVendaService();
